import React, {useRef} from 'react'
import styled from "@emotion/styled";
import {useSize} from "../../hooks/commons/RefSize";

// STYLE ##########################################################

const Container = styled(`div`)`
  display: flex;
  width: 100%;
  justify-content: center;
`;

const Background = styled('div')`
  position: absolute;
  ${props => props.side ? props.side + ": 0" : 'left: 0'};
  width: ${props => props.width ? props.width : '100%'};
  height: ${props => props.height ? props.height : ''};
  background: ${props => props.backgroundColor ? props.backgroundColor : ''};
	box-shadow: ${props => props.showBoxShadow ? '0 0 2px rgba(0, 0, 0, 0.06), 0 1px 1px rgba(0, 0, 0, 0.06)' : ''};
`;

// COMPONENT ##########################################################

export const StretchedBackground = (props) => {
	
	// set background height based on the parent container
	const containerRef = useRef(null);
	const size = useSize(containerRef);
	const height = (size && size.height) ? size.height : 0;
	
	return(
			<Container ref={containerRef}>
				
				{/* stretched background */}
				<Background
						height={height+"px"}
						backgroundColor={props.backgroundColor}
						side={props.side}
						width={props.width}
						showBoxShadow={props.showBoxShadow}
				/>
				
				{/* content */}
				{props.children}
				
			</Container>
	);
}